import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./plugins/i18n";
import filtersPlugin from "./plugins";
import installElementPlus from "./plugins/ElementUi"; // Alohida fayldan konfiguratsiya
import HighchartsVue from "highcharts-vue";
import penia from "./store/index";
import { getItem, setItem } from "./utils/storage";

const app = createApp(App);

window.onerror = function (msg, url, lineNo, columnNo, error) {
  let err_msg = "Uncaught SyntaxError: Unexpected token '<'";
  let err_url = "/js/chunk-";
  let currentDate = Math.floor(Date.now() / 1000);
  let chunk_err = getItem("chunk_err_date");

  let message = [
    "Message: " + msg,
    "URL: " + url,
    "Line: " + lineNo,
    "Column: " + columnNo,
    "Error object: " + JSON.stringify(error),
  ].join(" - ");

  if (msg.includes(err_msg)) {
    let secund = 5; // 5 - minutes
    if (!chunk_err || (chunk_err && chunk_err + secund < currentDate)) {
      setItem("chunk_err_date", currentDate);
      location.reload();
    }
  }
};

window.addEventListener('unhandledrejection', function (event) {
  const error = event.reason;
  let currentDate = Math.floor(Date.now() / 1000);
  let chunk_err = getItem("chunk_err_date");


  // Faqat ChunkLoadError bo'lsa
  if (error.name === 'ChunkLoadError' || /Loading chunk \d+ failed/.test(error.message)) {
    console.warn('Chunk load failed, reloading page...', error);
    let secund = 5; // 5 - minutes
    if (!chunk_err || (chunk_err && chunk_err + secund < currentDate)) {
      setItem("chunk_err_date", currentDate);
      location.reload();
    }
  }
});

const IGNORE_MESSAGES = [
  "ResizeObserver loop completed with undelivered notifications.",
];

// Filter some noisy runtime errors from reaching our custom handler
const originalOnError = window.onerror;
window.onerror = function (msg, source, lineno, colno, error) {
  if (typeof msg === "string" && IGNORE_MESSAGES.some((m) => msg.includes(m))) {
    // Returning true prevents the default browser error handler
    return true;
  }
  if (originalOnError) {
    return originalOnError(msg, source, lineno, colno, error);
  }
};

// Prevent webpack-dev-server overlay from reacting to ResizeObserver noise
window.addEventListener(
  "error",
  (event) => {
    if (
      event.message &&
      IGNORE_MESSAGES.some((m) => event.message.includes(m))
    ) {
      event.stopImmediatePropagation();
    }
  },
  true
);

installElementPlus(app); // Element Plus konfiguratsiyasini o'rnatish
app.use(penia);
app.use(router);
app.use(filtersPlugin);
app.use(HighchartsVue);
app.use(i18n);

app.mount("#app");

export { penia }